import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function truncateAddress(address, startChars = 6, endChars = 4) {
  if (!address) return '';
  if (address.length <= startChars + endChars) return address;
  return `${address.slice(0, startChars)}...${address.slice(-endChars)}`;
}

export function formatNumber(value, decimals = 2) {
  if (!value) return '0';
  const num = parseFloat(String(value).replace(/,/g, ''));
  if (isNaN(num)) return '0';
  
  if (num >= 1e9) {
    return (num / 1e9).toFixed(decimals) + 'B';
  }
  if (num >= 1e6) {
    return (num / 1e6).toFixed(decimals) + 'M';
  }
  if (num >= 1e3) {
    return (num / 1e3).toFixed(decimals) + 'K';
  }
  return num.toLocaleString(undefined, { maximumFractionDigits: decimals });
}

export function formatSmallPrice(price) {
  if (!price && price !== 0) return 'N/A';
  const num = parseFloat(price);
  if (num < 0.01) return `$${num.toFixed(8)}`;
  return `$${num.toFixed(6)}`;
}

export function formatTimestamp(timestamp) {
  if (!timestamp) return '';
  const date = new Date(timestamp);
  return date.toLocaleString(undefined, {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

export function timeAgo(timestamp) {
  if (!timestamp) return '';
  const now = new Date();
  const date = new Date(timestamp);
  const seconds = Math.floor((now - date) / 1000);
  
  if (seconds < 60) return 'just now';
  if (seconds < 3600) return `${Math.floor(seconds / 60)}m ago`;
  if (seconds < 86400) return `${Math.floor(seconds / 3600)}h ago`;
  if (seconds < 604800) return `${Math.floor(seconds / 86400)}d ago`;
  return formatTimestamp(timestamp);
}

export function getTokenColor(symbol) {
  const colors = {
    KROWN: { text: 'text-blue-500', bg: 'bg-blue-500/10', border: 'border-blue-500/20' },
    USDC: { text: 'text-sky-500', bg: 'bg-sky-500/10', border: 'border-sky-500/20' },
    USDT: { text: 'text-emerald-500', bg: 'bg-emerald-500/10', border: 'border-emerald-500/20' },
    ETH: { text: 'text-violet-500', bg: 'bg-violet-500/10', border: 'border-violet-500/20' },
  };
  return colors[symbol] || { text: 'text-primary', bg: 'bg-primary/10', border: 'border-primary/20' };
}

export function copyToClipboard(text) {
  if (navigator.clipboard && navigator.clipboard.writeText) {
    return navigator.clipboard.writeText(text);
  }
  // Fallback
  const textarea = document.createElement('textarea');
  textarea.value = text;
  document.body.appendChild(textarea);
  textarea.select();
  document.execCommand('copy');
  document.body.removeChild(textarea);
  return Promise.resolve();
}
